import React from "react";

const Calendar = () => {
  return (
    <div>
      <h1>Calendar Page</h1>
    </div>
  );
};

export default Calendar;
